/**
 * Table cells clip when they run out of room — except free text, which keeps
 * its ellipsis so a cut name or description reads as cut rather than as a
 * shorter value (compact-rows feedback 2026-09-10).
 *
 * Free text means prose the user typed: the record's own name/title, a
 * description or note, and any custom field declared as short/paragraph/rich
 * text. Structured values (dates, numbers, currency, status, references, and
 * built-in email/phone/website/slug columns) clip instead.
 */

/** Field types that hold prose when the column is a custom field. */
const FREE_TEXT_FIELD_TYPES = new Set(['STRING', 'TEXT', 'RICH_TEXT'])

/** Built-in columns that hold prose whatever their declared field type. */
const PROSE_COLUMN_IDS = new Set([
  'name',
  'title',
  'description',
  'subject',
  'notes',
  'note',
  'summary',
  'taskname',
  'workitem',
  'workitemname',
  'itemname',
  'displayname',
  'fullname',
  'firstname',
  'lastname',
  'companyname',
  'clientname',
  'projectname',
  // A typed job title ("Senior DevOps Engineer") was clipped mid-word.
  'jobtitle',
])

export function isFreeTextColumn(
  columnId: string,
  fieldType?: string,
  customFieldDefinitionId?: string,
): boolean {
  if (PROSE_COLUMN_IDS.has(columnId.toLowerCase())) return true
  return Boolean(
    customFieldDefinitionId &&
    fieldType &&
    FREE_TEXT_FIELD_TYPES.has(fieldType),
  )
}
